import {
  ValidationMessage,
  ValidationMessageFunction,
} from "@/models/validation-message";
import { z } from "zod";

export const getCreateUserSchema = () =>
  z.object({
    //username: z.string().nonempty({ message: ValidationMessage.NON_EMPTY }),
    name: z.string().nonempty({ message: ValidationMessage.NON_EMPTY }),
    phone: z
      .string()
      .nonempty({ message: ValidationMessage.NON_EMPTY })
      .max(30, ValidationMessageFunction.MAX(30)),
    email: z
      .string()
      .nonempty({ message: ValidationMessage.NON_EMPTY })
      .email({ message: ValidationMessage.EMAIL }),
    // password: z.string().nonempty({ message: ValidationMessage.NON_EMPTY }),
    // passwordRepeated: z
    //   .string()
    //   .nonempty({ message: ValidationMessage.NON_EMPTY })
    //   .refine((value) => value === passwordValue.value, ValidationMessage.REPEATED_PASSWORD)
  });
